import { render, staticRenderFns } from "./TrafficLight.vue?vue&type=template&id=e1b86c1a&scoped=true&"
import script from "./TrafficLight.vue?vue&type=script&lang=js&"
export * from "./TrafficLight.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLight.vue?vue&type=style&index=0&id=e1b86c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b86c1a",
  null
  
)

export default component.exports